import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat",
  "use": "icon-chat-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-chat\"><path d=\"M40 28a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM68 0H12A12 12 0 0 0 0 12v40a12 12 0 0 0 12 12h46.36l14.8 14.84A4.001 4.001 0 0 0 76 80a3.36 3.36 0 0 0 1.52-.32A4 4 0 0 0 80 76V12A12 12 0 0 0 68 0Zm4 66.36-9.16-9.2A4.001 4.001 0 0 0 60 56H12a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v54.36ZM24 28a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm32 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol